import { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { DASHBOARD } from '~/ui/constants/paths';

const Home = (): ReactElement => <Redirect to={DASHBOARD} />;

export default Home;
